module.exports = __webpack_public_path__ + "media/images/lb/042-a05fdc6199eefe0d3a28e6ca2897b45a.svg";